import type { ColDef } from "ag-grid-community";
import { TEMPLATE_TYPES } from "../../constants";

export const columnDef: ColDef[] = [
    {
        field: "Name",
        headerName: "Template Name",
        flex: 2,
    },
    {
        field: "Type",
        headerName: "Type",
        flex: 1,
        valueGetter: (params) => {
            return TEMPLATE_TYPES.find((t: { label: string; value: string }) => t.value === params.data?.Type)?.label || params.data?.Type;
        }
    },
    {
        field: "CreatedAt",
        headerName: "Created On",
        flex: 1,
        valueGetter: (params) => {
            return params.data?.CreatedAt ? new Date(params.data.CreatedAt).toLocaleDateString() : "";
        }
    },
    {
        headerName: "",
        field: "actions",
        flex: 0.5,
        minWidth: 80,
        sortable: false,
        filter: false,
        cellRenderer: "ActionsRenderer",
    }
];
